import { render, staticRenderFns } from "./NewModuleView.vue?vue&type=template&id=3b0c1e32&"
import script from "./NewModuleView.vue?vue&type=script&lang=js&"
export * from "./NewModuleView.vue?vue&type=script&lang=js&"
import style0 from "./NewModuleView.vue?vue&type=style&index=0&id=3b0c1e32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports